import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 47841D12-3D7E-40C1-9230-08C8890E0067
 * name window-open-variant
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/window-open-variant.svg
 * tags
 * - Home Automation 
 */
export const WindowOpenVariantIcon = createSvgIcon(<><path d="M21 20V2H3V20H1V23H23V20M19 4V11H17V4M5 4H7V11H5M5 20V13H7V20M9 20V4H15V20M17 20V13H19V20Z" /></>, 'WindowOpenVariantIcon');
export default WindowOpenVariantIcon